import { Flex, Spinner } from '@chakra-ui/react';
import UpdateAdvantagePlusShoppingSalesForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateAdvantagePlusShoppingSalesForm';
import UpdateAppPromotionForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateAppPromotionForm';
import UpdateAwarenessForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateAwarenessForm';
import UpdateCatalogueSalesForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateCatalogueSalesForm';
import UpdateEngagementForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateEngagementForm';
import UpdateLeadsForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateLeadsForm';
import UpdateSalesForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateSalesForm';
import UpdateTrafficeForm from 'components/campaignTables/Forms/AdsetForms/UpdationAdsetForms/UpdateTrafficeForm';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetAdsetByIDQuery, useGetAdsetFormQuery } from 'store/campaigns/adsetFormApi';
import { useGetcampaignByIdQuery } from 'store/campaigns/campaignsApi';
import { selectCampaignDataLoading, setCampaignDataLoading } from 'store/campaigns/campaignsSlice';

const AcrossAdSetUpdate = ({ selectedAdset, onClose, onSaveSuccess }) => {

    const { campaign_id : campaignId, account_id} = selectedAdset || {};
    const dispatch = useDispatch();
    const isCampaignsDataLoading = useSelector(selectCampaignDataLoading);
    
    const { data: campaignData, isLoading:isCampaignLoading, refetch:refetchCampaigns } = useGetcampaignByIdQuery(
        {campaignId, adsAccountId: account_id},
        { skip: !campaignId }
    );
    const adsAccountData = {
        account_id: selectedAdset?.account_id,
        name: selectedAdset?.account_name,
        timezone_name: selectedAdset?.timezone_name,
        currency: selectedAdset?.currency
    }

    const { data: adsetData, isLoading:isAdsetLoading } = useGetAdsetByIDQuery({
        adsAccountId:account_id,
        adsetId:selectedAdset?.adset_id
    }, { skip: !account_id || !selectedAdset?.adset_id });

    const isCampaignReady = !!campaignData && !!campaignData[campaignId];

    const campaignType = isCampaignReady ? campaignData[campaignId]?.objective : undefined;
    const smartPromotionType = campaignData && campaignData[campaignId]?.smart_promotion_type === 'AUTOMATED_SHOPPING_ADS';

    const productCatalogId = isCampaignReady
        ? campaignData[campaignId]?.promoted_object?.product_catalog_id
        : undefined;

    const baseSkip = campaignType !== 'OUTCOME_SALES';

    const shouldSkipSales = !isCampaignReady || baseSkip || !!productCatalogId;
    const shouldSkipCatalogueSales = !isCampaignReady || baseSkip || !productCatalogId;

    // Only when NO product_catalog_id
    const { data: dataSales, error: errorSales, isLoading: isLoadingSales } = useGetAdsetFormQuery(
        { campaign_type: 'OUTCOME_SALES' },
        { skip: shouldSkipSales }
    );
    
    // Only when product_catalog_id is present
    const { data: dataCatalogueSales, error: errorCatalogueSales, isLoading: isLoadingCatalogueSales } = useGetAdsetFormQuery(
        {
        campaign_type: 'OUTCOME_SALES',
        promoted_object: { product_catalog_id: productCatalogId }
        },
        { skip: shouldSkipCatalogueSales }
    );

    const { data: dataLeads, error: errorLeads, isLoading: isLoadingLeads } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_LEADS' }, { skip: campaignType !== 'OUTCOME_LEADS' }); 
    const { data: dataAwareness, error: errorAwareness, isLoading: isLoadingAwareness } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_AWARENESS' }, { skip: campaignType !== 'OUTCOME_AWARENESS' }); 
    const { data: dataEngagement, error: errorEngagement, isLoading: isLoadingEngagement } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_ENGAGEMENT' }, { skip: campaignType !== 'OUTCOME_ENGAGEMENT' }); 
    const { data: dataTraffic, error: errorTraffic, isLoading: isLoadingTraffic } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_TRAFFIC' }, { skip: campaignType !== 'OUTCOME_TRAFFIC' }); 
    const { data: dataAppPromotions, error: errorAppPromotions, isLoading: isLoadingAppPromotions } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_APP_PROMOTION' }, { skip: campaignType !== 'OUTCOME_APP_PROMOTION' }); 
    const { data: dataAdvantageShopping, isLoading: isLoadingAdvantageShopping } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_SALES',  smart_promotion_type : 'AUTOMATED_SHOPPING_ADS' }, { skip: campaignType !== 'OUTCOME_SALES' || !smartPromotionType });      

    useEffect(() => {
        if (isCampaignsDataLoading) {
                refetchCampaigns();
                dispatch(setCampaignDataLoading(false));
        }
    }, [isCampaignsDataLoading]);

    const renderForm = () => {
  
        if (isLoadingSales || isLoadingLeads || isLoadingAppPromotions || isLoadingAdvantageShopping || isAdsetLoading || isCampaignLoading || isLoadingAwareness || isLoadingEngagement || isLoadingCatalogueSales) {
            return (
                <Flex justify="center" align="center" height="70vh">
                    <Spinner size="md" />
                </Flex>
            );
        }

        if (campaignType === 'OUTCOME_SALES' && !smartPromotionType && dataSales?.data && campaignData) {
            return (
                <UpdateSalesForm
                    adsAccountData={adsAccountData}
                    data={dataSales?.data}
                    campaignData={campaignData}
                    selectedAdset={adsetData}
                    onEditModalClose={onClose}
                    onClose={onClose}
                    context="adsetEdit"
                    onSaveSuccess={onSaveSuccess}
                />
            );
        } else if (campaignType === 'OUTCOME_SALES' && !smartPromotionType && dataCatalogueSales?.data && campaignData) {
            return (
                <UpdateCatalogueSalesForm
                    adsAccountData={adsAccountData}
                    data={dataCatalogueSales?.data}
                    campaignData={campaignData}
                    selectedAdset={adsetData}
                    onEditModalClose={onClose}
                    onClose={onClose}
                    context="adsetEdit"
                    onSaveSuccess={onSaveSuccess}
                />
            );
        } else if (campaignType === 'OUTCOME_LEADS' && !smartPromotionType && dataLeads?.data && campaignData) {
            return (
                <UpdateLeadsForm
                    adsAccountData={adsAccountData}
                    data={dataLeads?.data}
                    campaignData={campaignData}
                    selectedAdset={adsetData}
                    onEditModalClose={onClose}
                    onClose={onClose}
                    context="adsetEdit"
                    onSaveSuccess={onSaveSuccess}
                />
            );
        } else if (campaignType === 'OUTCOME_SALES' && smartPromotionType  && dataAdvantageShopping && campaignData ) {
            return <UpdateAdvantagePlusShoppingSalesForm
                    adsAccountData={adsAccountData}
                    data={dataAdvantageShopping?.data}
                    campaignData={campaignData}
                    selectedAdset={adsetData}
                    onEditModalClose={onClose}
                    onClose={onClose}
                    context="adsetEdit"
                    onSaveSuccess={onSaveSuccess}
            />
        } else if (campaignType === 'OUTCOME_APP_PROMOTION' && !smartPromotionType && dataAppPromotions && campaignData ) {
            return (
                  <UpdateAppPromotionForm
                      data={dataAppPromotions?.data}
                      campaignData={campaignData}
                      adsAccountData={adsAccountData}
                      selectedAdset={adsetData}
                      onEditModalClose={onClose}
                      onClose={onClose}
                      context="adsetEdit"
                      onSaveSuccess={onSaveSuccess}
                  />
            );
        } else if (campaignType === 'OUTCOME_AWARENESS' && !smartPromotionType  && dataAwareness && campaignData ) {
            return (
                  <UpdateAwarenessForm
                      data={dataAwareness?.data}
                      campaignData={campaignData}
                      adsAccountData={adsAccountData}
                      selectedAdset={adsetData}
                      onEditModalClose={onClose}
                      onClose={onClose}
                      context="adsetEdit"
                      onSaveSuccess={onSaveSuccess}
                  />
            );
        } else if (campaignType === 'OUTCOME_ENGAGEMENT' && !smartPromotionType  && dataEngagement && campaignData ) {
            return (
                  <UpdateEngagementForm
                      data={dataEngagement?.data}
                      campaignData={campaignData}
                      adsAccountData={adsAccountData}
                      selectedAdset={adsetData}
                      onEditModalClose={onClose}
                      onClose={onClose}
                      context="adsetEdit"
                      onSaveSuccess={onSaveSuccess}
                  />
            );
        } else if (campaignType === 'OUTCOME_TRAFFIC' && !smartPromotionType  && dataTraffic && campaignData ) {
            return (
                  <UpdateTrafficeForm
                      data={dataTraffic?.data}
                      campaignData={campaignData}
                      adsAccountData={adsAccountData}
                      selectedAdset={adsetData}
                      onEditModalClose={onClose}
                      onClose={onClose}
                      context="adsetEdit"
                      onSaveSuccess={onSaveSuccess}
                  />
            );
        }
        return null;
    };

    return (
        <>
         {renderForm()}
        </>    
    );
};

export default AcrossAdSetUpdate;
